import {Component, OnInit, Inject} from 'ng-metadata/core';
import {TagsService, TagItem} from './tags.service';
import {UserSessionManagerService} from  '../security/userSessionManager.service';
import {IAlertMsg} from '../infra/widgets/alerts/alertMsg.interface';
import {AlertFactory,ALERT_MSG_TYPE} from '../infra/widgets/alerts/alertFactory.service';
    
@Component({
    selector: 'prm-tags',
    templateUrl: 'components/tags/tags.html',
})

export class PrmTags{
        
     private borInfoAlert :IAlertMsg;
    
     constructor(private userSessionManagerService:UserSessionManagerService,
                 private tagsService: TagsService,
                 private alertService:AlertFactory,
                 @Inject('$location') private $location: ng.ILocationService) {
         this.tagsService.getTagsFromApi();
         this.tagsService.isInSearch = false;
         this.borInfoAlert = alertService.create(ALERT_MSG_TYPE.SIGNIN);
         this.borInfoAlert.show('nui.bor_info_failed');
    }
    
    private userLoggedIn(){
        return this.userSessionManagerService.getUserName().length > 0;
    }
        
    private isInSearch(){
        return this.tagsService.isInSearch;
    }    

    public get popularTags() {
        return this.tagsService.popularTags;
    }
    
    public get recentTags() {
        return this.tagsService.recentTags;
    }
    
    public get myTags() {
        return this.tagsService.myTags;
    }
    
    private displayBorInfoAlert() {
       if (this.$location.search()['authenticationError'] && this.$location.search()['authenticationError'] === '1'){
            return true;
        }
        return false;
    }
    
    
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/tags/tags.directive.ts